import { useFormik, Form, FormikProvider } from "formik";
import { Button } from "styled";
import InputField from "components/formik/InputField";
import Model from "components/Modal";
import { createDocument } from "apis/customApiHandler";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";

const AddTrainingMaterial = ({ handleClick }) => {
  const queryClient = useQueryClient();
  const formik = useFormik({
    initialValues: {
      name: "",
      documents: [],
    },
    onSubmit: async (values) => {
      const array = values.documents[0].split(".");
      const type = array[array.length - 1]
      console.log({type})
      const data = await createDocument("training-material", {...values, type});
      if (data) {
        toast.success("Successfully saved");
        queryClient.invalidateQueries("training-materials");
      }
      handleClick();
    },

    validate: (values) => {
      let errors = {};
      if (!values.name) errors.name = "Required";
      if (!values.documents?.length) errors.documents = "Required";
      return errors;
    },
  });

  return (
    <Model
      handleClick={handleClick}
      title={"Add Training Material"}
      className="max-w-2xl"
    >
      <FormikProvider value={formik}>
        <Form className="px-5 text-gray-700 font-medium text-base grid  lg:gap-x-14 gap-y-5 grid-flow-row grid-cols-1 lg:grid-cols-2 w-full">
          <div className= "col-span-2">
          <InputField type="text" label="Training Material Name" name="name" />
          </div>
          <InputField type="file" limit={1} label="Training Content" name="documents" formik={formik} />
        </Form>
        <div className="px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full">
          <Button bgSecondary onClick={handleClick}>
            Cancel
          </Button>
          <Button type="button" bgPrimary onClick={formik.handleSubmit}>
            Save Changes
          </Button>
        </div>
      </FormikProvider>
    </Model>
  );
};

export default AddTrainingMaterial;
